import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// mui
import { Avatar, Button, Stack, TextField, Typography } from '@mui/material';
// component

// lib & store
import { copy } from '@/lib/util';
import { useSendInfoActions, useSendNftInfoActions, SendState, SendNftState } from '@/store/zustand/store';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import TopBackButton from '@/component/common/top-back-button';
import SFSendIcon from '@/component/icons/sf-send-icon';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import theme, { inter } from '@/theme';
import { ShortenTxId } from '@/lib/Shorten';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useEffectOnce } from 'usehooks-ts';

export default function SendSuccess() {
  const { t } = useTranslation();
  // const type = 'base';
  // const data = { hash: '0xc9186c7f4c30742981ffa8731269e1bfbc34a05aa4266d87443c576aba5357b5' };
  const {
    state: { type, data },
  } = useLocation();
  const navigate = useNavigate();
  const { setSendInfo } = useSendInfoActions();
  const { setSendNftInfo } = useSendNftInfoActions();

  // useEffect(() => {
  //   (() => {
  //     toast.success('전송 성공 (잠시 후 이동합니다.)');
  //     switch (type) {
  //       case 'base':
  //       case 'tri':
  //         initSendInfo();
  //         returnPage('/wallet');
  //         break;
  //       case 'nft':
  //         initSendNftInfo();
  //         returnPage('/nft');
  //         break;
  //       default:
  //         break;
  //     }
  //   })();

  //   return () => {};
  // }, []);

  useEffectOnce(() => {
    if (type === 'nft') {
      initSendNftInfo();
      returnPage('/nft');
    } else {
      initSendInfo();
      returnPage('/wallet');
    }
  });
  useEffectOnce(() => {
    if (data.hash.startsWith('Err')) {
      navigate('/sendFail');
    }
  });

  const initSendInfo = () => {
    const payload: SendState = {
      from: '',
      to: '',
      value: '',
    };
    setSendInfo(payload);
  };
  const initSendNftInfo = () => {
    const payload: SendNftState = {
      fromAddr: null,
      toAddr: null,
      contract: undefined,
      tokenId: null,
      tokenType: '',
    };
    setSendNftInfo(payload);
  };

  const returnPage = (aPath = '/wallet') => {
    setTimeout(() => {
      navigate(aPath);
    }, 12000);
  };
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '653px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title="보내기 성공"
        boxProps={{
          mb: 4,
        }}
        backPath={type === 'nft' ? '/nft' : '/wallet'}
      />
      <Box mb={7} />
      <Avatar
        sx={{
          width: 60,
          height: 60,
          border: '2px solid white',
          bgcolor: theme.palette.primary.main,
          margin: 'auto',
        }}
      >
        <NorthEastIcon />
      </Avatar>
      <Box mb={2} />
      <Stack
        sx={{
          textAlign: 'center',
          fontWeight: 900,
        }}
      >
        전송에 성공하였습니다.
      </Stack>
      <Stack
        sx={{
          textAlign: 'center',
        }}
      >
        ※ 10초 후 자동으로 화면이 이동합니다.
      </Stack>
      <Box mb={3} />
      <Typography variant="body2" mb={1}>
        <b>Transaction Hash</b>
      </Typography>
      <TextField disabled fullWidth defaultValue={data.hash} />

      <Box position="absolute" bottom={10} left={0} width="100%" padding={3}>
        <Button
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(`${data.blockExplorerUrl}/tx/${data.hash}`);
              toast.success(`${t('toast.copyTransactionHash')}`);
            } catch (err) {
              console.error('클립보드 복사 실패:', err);
            }
          }}
          fullWidth
          size="large"
          variant="contained"
        >
          <Typography variant="subtitle2" fontWeight={700} fontFamily={inter.style.fontFamily} textTransform="none">
            트랜잭션 링크 복사
          </Typography>
        </Button>
        <Box mb={1} />
        {/* 전송 성공 후 트랜잭션 생성 전이라서 스캔에 잡히지 않음
        <Button
          onClick={() => {
            window.open(`${data.blockExplorerUrl}tx/${data.hash}`);
          }}
          fullWidth
          size="large"
          variant="outlined"
        >
          <Typography variant="subtitle2" fontWeight={700} fontFamily={inter.style.fontFamily} textTransform="none">
            스캔으로 이동
          </Typography>
        </Button> */}
      </Box>
    </Container>
  );
}
